import { SectionHubPage } from "../../components/SectionHubPage/SectionHubPage";
import { movementPartiesHubCards } from "../../navigation/appNavigation";

const MovementPartiesHubPage = () => (
    <SectionHubPage title="Movement & Parties" cards={movementPartiesHubCards} />
);

export { MovementPartiesHubPage };
